// The V6 design's point-of-care styles (Aithora ConsoleV6.dc.html pwLayer, and
// point-of-care.js P.vm), copied value for value so the dark-mode map applies.

/** A choice chip (pwLayer chip(on, red)). */
export const chip = (on: boolean, red = false) =>
  'display:inline-flex;align-items:center;min-height:36px;padding:0 13px;border-radius:18px;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;box-sizing:border-box;' +
  (on ? (red ? 'background:#B3261E;color:#FFFFFF;border:1px solid #B3261E;' : 'background:#264C7E;color:#FFFFFF;border:1px solid #264C7E;') : 'background:#FFFFFF;color:#22272E;border:1px solid rgba(34,39,46,.2);');

/**
 * A primary button (pwLayer prim(ok, red)). The design's "not ready" look is grey; the
 * console keeps it clickable only where the server's answer is the point (Sign).
 */
export const prim = (ok: boolean, red = false) =>
  'display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:0 18px;border-radius:9px;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;' +
  (ok ? (red ? 'background:#B3261E;color:#FFFFFF;' : 'background:#264C7E;color:#FFFFFF;') : 'background:rgba(34,39,46,.08);color:#54606C;');

/** A white card in a sheet. */
export const CARD = 'display:flex;flex-direction:column;gap:7px;padding:12px;border-radius:10px;background:#FFFFFF;border:1px solid rgba(34,39,46,.12);';
/** A section head in the incident sheet. */
export const HEAD = 'font-size:14px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;color:#54606C;margin-top:4px;';
/** A section head in the scan sheet. */
export const STEP = 'font-size:14px;letter-spacing:.12em;text-transform:uppercase;font-weight:700;color:#54606C;margin-top:6px;';
/** A stop: wrong medicine, a count that does not match. */
export const ALERT = 'padding:10px 12px;border-radius:10px;background:#FBEDEC;border:1px solid rgba(179,38,30,.4);font-size:16px;font-weight:800;color:#8A1C16;line-height:1.4;';
/** The note under a sheet's content. */
export const NOTE = 'font-size:16px;color:#54606C;line-height:1.45;';
/** A number field (the scan's pulse, the count). */
export const NUM = 'min-height:36px;box-sizing:border-box;padding:0 10px;border-radius:9px;border:1px solid rgba(34,39,46,.2);background:#FFFFFF;font-family:inherit;font-size:16px;font-weight:700;color:#22272E;';
/** A text field for a scanned code (the console has no camera). */
export const CODE = 'box-sizing:border-box;width:100%;min-height:36px;padding:0 10px;border-radius:9px;border:1px solid rgba(34,39,46,.2);background:#FFFFFF;font-family:inherit;font-size:16px;color:#22272E;';
/** A ticked or empty check box (the immediate steps). */
export const box = (on: boolean) =>
  'flex:0 0 22px;width:22px;height:22px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;font-size:16px;font-weight:800;' +
  (on ? 'background:#1F6B52;color:#FFFFFF;' : 'background:#FFFFFF;border:1.5px solid rgba(34,39,46,.35);color:transparent;');

const H = 3_600_000;
const M = 60_000;
/** "23 h 9 m" (point-of-care.js P.left). */
export const left = (ms: number) => {
  const a = Math.abs(ms);
  const h = Math.floor(a / H);
  const m = Math.floor((a % H) / M);
  return (h ? `${h} h ` : '') + `${m} m`;
};
/** "3:12 AM" (point-of-care.js P.hhmm). */
export const hhmm = (t: string | number) => {
  const d = new Date(t);
  let h = d.getHours();
  const ap = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  return `${h}:${String(d.getMinutes()).padStart(2, '0')} ${ap}`;
};
/** "Oct 19". */
export const day = (t: string) => new Date(t).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
